import React, { useEffect } from 'react';

const REDIRECT_URL = 'https://www.ibdassist.com/pages/hashi-aid-or-full-spectrum-thyroid-support';

const Step11 = ({ data, onSelect, overrides }) => {
  // Listen for Klaviyo form submission and redirect
  useEffect(() => {
    const observer = new MutationObserver(() => {
      const successMsg = document.querySelector('.klaviyo-form-Vh2NWS .go3958317564');
      const thankYou = document.querySelector('.klaviyo-form-Vh2NWS [data-testid="form-row"]');
      if (successMsg || document.querySelector('.klaviyo-form-Vh2NWS .needsClick')) {
        // Check if form was submitted by looking for success state
        const formEl = document.querySelector('.klaviyo-form-Vh2NWS');
        if (formEl && formEl.querySelector('button[type="button"]') === null && formEl.textContent.includes('Thank')) {
          window.location.href = REDIRECT_URL;
        }
      }
    });

    const formContainer = document.querySelector('.klaviyo-form-Vh2NWS');
    if (formContainer) {
      observer.observe(formContainer, { childList: true, subtree: true, attributes: true });
    }

    // Also intercept form submit via click listener
    const handleClick = (e) => {
      const btn = e.target.closest('.klaviyo-form-Vh2NWS button');
      if (btn) {
        setTimeout(() => {
          const formEl = document.querySelector('.klaviyo-form-Vh2NWS');
          const inputs = formEl?.querySelectorAll('input[type="email"]');
          const hasEmail = inputs && Array.from(inputs).some(i => i.value && i.value.includes('@'));
          if (hasEmail) {
            setTimeout(() => { window.location.href = REDIRECT_URL; }, 1500);
          }
        }, 500);
      }
    };
    document.addEventListener('click', handleClick);

    return () => {
      observer.disconnect();
      document.removeEventListener('click', handleClick);
    };
  }, []);
  const gifts = [
    {
      name: '28-Day Gut Reboot Guide',
      value: '$47 Value',
      image: 'https://customer-assets.emergentagent.com/job_34c4e86f-46e3-4691-bde6-c1a4909c11ff/artifacts/lteae8q2_masterclassimage_10.png'
    }
  ];

  return (
    <div className="flex flex-col">
      {/* Heading */}
      <h1 className="font-serif text-4xl md:text-5xl leading-tight mb-8" style={{ color: '#1a1a2e' }}>
        Unlock <span className="gradient-text">50% off</span> and 1 free gift with your email.
      </h1>

      {/* Product Card with Discount Badge */}
      <div className="relative mb-6">
        {/* Discount Badge */}
        <div 
          className="absolute top-3 left-3 z-10 px-4 py-2 rounded-full text-sm font-medium text-white"
          style={{ 
            background: 'linear-gradient(135deg, #7874F8 0%, #09C9E9 100%)',
            boxShadow: '0 4px 15px rgba(120, 116, 248, 0.3)'
          }}
        >
          50% off Hashi-aid
        </div>
        
        {/* Product Image Card */}
        <div className="product-card p-6">
          <div className="flex justify-center">
            <div className="relative w-48 h-44 flex items-center justify-center">
              <img 
                src="https://customer-assets.emergentagent.com/job_quiz-journey-8/artifacts/v2lfdhha_Hashi-aid_FRONT.png"
                alt="Hashi-aid Thyroid Support"
                className="max-h-full max-w-full object-contain"
                style={{
                  filter: 'drop-shadow(0 10px 30px rgba(120, 116, 248, 0.2))'
                }}
              />
            </div>
          </div>
        </div>
      </div>

      {/* Bonus Gifts Section */}
      <div className="flex flex-col gap-3 mb-8">
        {gifts.map((gift, index) => (
          <div 
            key={index}
            className="flex items-center gap-4 p-3 rounded-lg border"
            style={{ 
              borderColor: '#e8e8e8',
              background: '#fafafa'
            }}
          >
            {/* Gift image */}
            <div 
              className="w-16 h-16 rounded-lg flex-shrink-0 overflow-hidden"
              style={{ 
                background: '#fff',
                border: '1px solid #eee'
              }}
            >
              <img 
                src={gift.image}
                alt={gift.name}
                className="w-full h-full object-cover"
              />
            </div>
            
            {/* Gift details */}
            <div className="flex-1">
              <p className="text-sm font-medium" style={{ color: '#333' }}>{gift.name}</p>
              <p className="text-xs" style={{ color: '#888' }}>{gift.value}</p>
            </div>
            
            {/* Price */}
            <span className="text-sm font-medium gradient-text">Free</span>
          </div>
        ))}
      </div>

      {/* Klaviyo Email Form */}
      <div className="klaviyo-form-Vh2NWS"></div>
    </div>
  );
};

export default Step11;
